import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: 'en',
    resources: {
        ru: { translation: require('../../public/locales/ru_translation.json') },
        en: { translation: require('../../public/locales/en_translation.json') },
    },
    interpolation: { escapeValue: false },
    detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
    },
});
export default i18n;
